import { Paginated } from "./utils";

export enum IntegrationStatus {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
}

/** Publication channels of a job offer, switchable one by one while it is active. */
export enum JobOfferChannel {
  KLEINANZEIGEN = "kleinanzeigen",
  EXTERNAL_EMBED = "externalEmbed",
  GOOGLE_JOBS = "googleJobs",
}

export interface ChangeJobOfferChannelRequestDto {
  active: boolean;
}

export interface CreateJobOfferRequestDto {
  title: string;
  description: string;
  applicantProfile: string;
  employeeBenefits: string;
  employmentStart: string;
  belongsToWorkingTimeModels: string[];
  belongsToCompanyLocationId: string;
  postCode?: string;
  applicationLink?: string;
  hourlySalary?: number;
}

export interface JobOfferResponseDto {
  belongsToOrganizationId: string;
  createdAt: string;
  updatedAt: string;
  _id: string;
  title: string;
  description: string;
  applicantProfile: string;
  employeeBenefits: string;
  employmentStart: string;
  isActive: boolean;
  applicantCount: number;
  kleinanzeigenStatus: IntegrationStatus;
  externalEmbedStatus: IntegrationStatus;
  googleJobsStatus: IntegrationStatus;
  kleinanzeigenUrl?: string;
  activeSince: string;
  belongsToWorkingTimeModels: string[];
  belongsToCompanyLocationId: string;
  companyLocationEditable: boolean;
}

export interface JobOfferListResponseDto {
  _id: string;
  title: string;
  isActive: boolean;
  applicantCount: number;
  kleinanzeigenStatus: IntegrationStatus;
  kleinanzeigenAllowed: boolean;
  activeSince: string | null;
  externalEmbedActive: boolean;
  externalEmbedStatus: IntegrationStatus;
  googleJobsStatus: IntegrationStatus;
}

export interface CompanyLocationSelectableListResponseDto {
  _id: string;
  value: string;
}

export interface JobOfferListWithCompanyLocationsPaginatedResponseDto {
  jobOffers: Paginated<JobOfferListResponseDto>;
  foundCompanyLocationId: string;
  companyLocations: CompanyLocationSelectableEntityResponseDto[];
}

export interface CompanyLocationSelectableEntityResponseDto {
  _id: string;
  value: string;
  jobOfferCount: number;
  activeJobOfferCount: number;
  isArchive: boolean;
}

export interface WorkingTimeModelSelectableEntityResponseDto {
  id: string;
  value: string;
}

export interface JobOfferCreationEntitiesResponseDto {
  companyLocations: CompanyLocationSelectableEntityResponseDto[];
  workingTimeModels: WorkingTimeModelSelectableEntityResponseDto[];
  employeeBenefitsTemplate: string;
}

export interface JobOfferSelectableEntitiesResponseDto {
  companyLocations: CompanyLocationSelectableEntityResponseDto[];
  workingTimeModels: WorkingTimeModelSelectableEntityResponseDto[];
}

export interface JobOfferDetailsResponseDto {
  _id: string;
  title: string;
  description: string;
  applicantProfile: string;
  employeeBenefits: string;
  employmentStart: string;
  active: boolean;
  applicantCount: number;
  imageUrl?: string;
  kleinanzeigenUrl?: string;
  kleinanzeigenStatus: IntegrationStatus;
  externalEmbedStatus: IntegrationStatus;
  googleJobsStatus: IntegrationStatus;
  activeSince: string;
  belongsToWorkingTimeModels: string[];
  belongsToCompanyLocationId: string;
  postCode: string;
  applicationLink: string;
  hourlySalary: number;
  titleEditable: boolean;
  companyLocationEditable: boolean;
  isEditable: boolean;
  selectableEntities: JobOfferSelectableEntitiesResponseDto;
}

export interface UpdateJobOfferRequestDto {
  title: string;
  description: string;
  applicantProfile: string;
  employeeBenefits: string;
  employmentStart: string;
  workingTimeModels: string[];
  belongsToCompanyLocationId: string;
}
